import React from 'react';
import type { IconProps } from './types';

export const StackOverflow = ({ onClick }: IconProps) => (
  <div role="none" className="icon icon-stackoverflow" onClick={onClick}>
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.01587" y="14.1537" width="6.38583" height="1" rx="0.5" fill="#707E8B" />
      <rect
        x="3.17358"
        y="11.7006"
        width="6.38583"
        height="1"
        rx="0.5"
        transform="rotate(5.35706 3.17358 11.7006)"
        fill="#707E8B"
      />
      <rect
        x="3.73364"
        y="8.7439"
        width="6.38583"
        height="1"
        rx="0.5"
        transform="rotate(15.0768 3.73364 8.7439)"
        fill="#707E8B"
      />
      <rect
        x="5.14893"
        y="5.4657"
        width="6.38583"
        height="1"
        rx="0.5"
        transform="rotate(30.4801 5.14893 5.4657)"
        fill="#707E8B"
      />
      <rect
        x="8.39502"
        y="2.29907"
        width="6.38583"
        height="1"
        rx="0.5"
        transform="rotate(55.9745 8.39502 2.29907)"
        fill="#707E8B"
      />
      <rect
        x="12.5151"
        y="0.85022"
        width="6.38583"
        height="1"
        rx="0.5"
        transform="rotate(80.3258 12.5151 0.85022)"
        fill="#707E8B"
      />
      <path
        d="M0.887207 11.5322C0.887207 11.2383 1.12546 11 1.41936 11C1.71326 11 1.95151 11.2383 1.95151 11.5322V17.3858H0.887207V11.5322Z"
        fill="#707E8B"
      />
      <rect
        x="11.998"
        y="16.3215"
        width="1.0643"
        height="10.0465"
        transform="rotate(90 11.998 16.3215)"
        fill="#707E8B"
      />
      <path
        d="M10.9338 11.5322C10.9338 11.2383 11.1721 11 11.466 11C11.7599 11 11.9981 11.2383 11.9981 11.5322V17.3858H10.9338V11.5322Z"
        fill="#707E8B"
      />
    </svg>
  </div>
);
